import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaCar } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const ViewOrderProductScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderItemId: routeOrderItemId } = useParams();
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    const orderItemId = routeOrderItemId || location.state?.orderItemId;
    if (!orderItemId) return;
    const token = localStorage.getItem("userToken");
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    fetch(`${process.env.REACT_APP_API_URL}/api/orders/item/${orderItemId}`, {
      headers,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.success === false) {
          setOrderData(null);
          return;
        }
        setOrderData(data || null);
      })
      .catch(() => {
        setOrderData(null);
      });
  }, [location.state, routeOrderItemId]);

  const product = orderData?.productDetails || orderData?.product || orderData?.item || orderData?.items?.[0] || {};
  const orderMeta = orderData?.orderSummary || orderData?.orderMeta || orderData?.order || {};
  const productImage = product?.productImages?.[0] || product?.productImage || "/New%20Image.jpeg";
  const productName = product?.productName || "Shoe";
  const productDescription = product?.description || product?.productDescription || "Very Good Nike";
  const productPrice = orderMeta?.amount ?? product?.price ?? "20,000";
  const productQuantity = orderMeta?.orderQuantity ?? product?.quantity ?? "41";
  const productCategory = product?.category || product?.productCategory || "Fashion";
  const vendorStoreName = product?.vendorName || "Debz Cosmetics Store";
  const orderNumber = orderMeta?.orderNumber || product?.orderNumber || "123456";
  const createdAt = orderMeta?.createdAt ? new Date(orderMeta.createdAt) : (orderMeta?.orderDate ? new Date(orderMeta.orderDate) : (orderData?.createdAt ? new Date(orderData.createdAt) : null));
  const orderDate = createdAt ? createdAt.toLocaleDateString() : "11/9/2026";
  const orderTime = createdAt ? createdAt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }).toLowerCase() : "3:32pm";
  const deliveryCode = orderMeta?.deliveryConfirmationCode || orderData?.deliveryCode || orderData?.confirmationCode || "654321";
  const paymentStatus = orderMeta?.paymentStatus || "Paid";
  const productStatus = orderMeta?.orderStatus || product?.orderStatus || "Delivering";

  return (
    <div className="flex flex-col h-screen">
      <header className="sticky top-0 z-10 bg-white shadow-sm" style={{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '12px', paddingBottom: '12px' }}>
        <div className="flex items-center justify-center relative">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="absolute left-4 flex h-10 w-10 items-center justify-center"
            aria-label="Go back"
          >
            <FaArrowLeft className="h-5 w-5 text-gray-800" />
          </button>
          <h1 className="text-base font-semibold text-gray-900" style={{ fontSize: '20px', padding: '2px', color: 'black' }}>
            Order #<span>{orderNumber}</span>
          </h1>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto bg-gray-50 p-4" style={{ gap: '12px', display: 'flex', flexDirection: 'column', paddingLeft: '8px', paddingRight: '8px' }}>
        <div className="flex justify-between text-sm text-gray-600" style={{ padding: '2px', color: 'black', fontSize: '14px' }}>
          <span style={{ padding: '4px', fontSize: '18px', fontWeight: 600, color: '#000000' }}>{orderDate}</span>
          <span style={{ padding: '4px', fontSize: '18px', fontWeight: 600, color: '#000000' }}>{orderTime}</span>
        </div>

        <div style={{ height: '50%' }}>
          <img
            loading="lazy"
            src={productImage}
            alt="Product"
            className="w-full rounded-xl object-contain bg-gray-100" style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>

        <div className="rounded-xl bg-white text-left" style={{ padding: '8px', gap: '2px', boxShadow: '0px 0px 4px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column' }}>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Name: <span>{productName}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Description: <span>{productDescription}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Price: <span className="text-base font-bold">₦{Number(productPrice || 0).toLocaleString("en-NG")}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Quantity: <span>{productQuantity}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Category: <span>{productCategory}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Vendor Store: <span>{vendorStoreName}</span>
          </p>
        </div>

        <div className="rounded-xl bg-white p-4 shadow-sm text-left items-start" style={{ padding: '8px', boxShadow: '0px 0px 4px rgba(0,0,0,0.25)', color: '#000000' }}>
          <div className="flex items-start gap-3">
            <FaCar className="mt-1 h-5 w-5 text-gray-700" />
            <div>
              <p className="text-sm font-semibold text-gray-900" style={{ padding: '2px', fontSize: '16px', fontWeight: 500, color: 'black' }}>Door Delivery</p>
              <p className="text-xs text-gray-600" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>Delivery in 3 days</p>
            </div>
          </div>
        </div>

        <div className="product-ID-delivery-confirmation p-4 shadow-sm" style={{ padding: 0, background: 'none' }}>
          <div className="rounded-xl bg-white shadow-sm text-left items-start" style={{ padding: '8px', boxShadow: '0px 0px 4px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <p className="product-ID-text text-gray-700" style={{ fontSize: '16px', fontWeight: 500 }}>
              Product ID: <span>{product?.productId || orderData?.productId || orderNumber}</span>
            </p>
            <p className="delivery-Code text-gray-700" style={{ fontSize: '16px', fontWeight: 500 }}>
              Delivery confirmation code: <span>{deliveryCode}</span>
            </p>
          </div>
          <div className="mt-3 flex items-center gap-3 text-left" style={{ alignItems: 'center' }}>
            <span className="flex items-center justify-center h-4 w-4 rounded-full bg-[#19C463] shadow-sm ring-1 ring-gray-100">
              <IoInformationCircleOutline className="text-white" style={{ width: 13, height: 13 }} />
            </span>
            <p style={{ textAlign: 'left', fontSize: '12px', fontWeight: 500, color: '#000000', padding: '2px', margin: 0 }}>
              Your delivery confirmation code will be used by you to confirm your product has been delivered to you. Do not share it with anyone.
            </p>
          </div>
        </div>

        <div className="rounded-xl bg-white text-left items-start" style={{ padding: '8px', boxShadow: '0px 0px 4px rgba(0,0,0,0.25)', color: '#000000', display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Payment Status: <span>{paymentStatus}</span>
          </p>
          <p className="text-sm text-gray-700" style={{ padding: '2px', fontSize: '16px', fontWeight: 500 }}>
            Product Status: <span>{productStatus}</span>
          </p>
        </div>
      </main>
    </div>
  );
};

export default ViewOrderProductScreen;


